export default class OmnichannelHTTPHeaders {
  public static readonly authenticatedUserToken = `AuthenticatedUserToken`;
  public static readonly authorization = `Authorization`;
  public static readonly organizationId = `OrganizationId`;
  public static readonly widgetAppId = `widgetAppId`;
  public static readonly requestId = `Request-Id`;
  public static readonly authCodeNonce = `AuthCodeNonce`;
}
